import React, { FC } from 'react'

import { StandardButton, Txt } from 'src/components/atoms'

import { useAuthority } from 'src/hooks'

type Props = {
  onClickAddProject: () => void
  className?: string
}

export const NoAssignProject: FC<Props> = ({ onClickAddProject, className }) => {
  const { canAssignProject } = useAuthority()

  return (
    <div className={className}>
      <div className="tw-flex tw-flex-col tw-items-center">
        <Txt className="tw-text-standardText-secondary">
          アサインされているプロジェクトが存在しません
        </Txt>

        {canAssignProject && (
          <StandardButton
            buttonType="secondary"
            text="プロジェクト追加"
            prependIconPath="plus/soft/line"
            onClick={onClickAddProject}
            className="tw-mt-s2"
          />
        )}
      </div>
    </div>
  )
}
